export { IconInstagram1 } from "./IconInstagram1";
